import { useState, useEffect } from 'react';
import ConversationService from '../services/ConversationService';

// An empty list is the resting state: no traced send, or no answer from the route.
function useSentMessages(conversationId) {
    const [sentMessages, setSentMessages] = useState([]);
    const { getSentMessages } = ConversationService;

    async function setUpSentMessages() {
        const [response, errors] = await getSentMessages(conversationId);
        if (errors != null) {
            console.log(errors)
            return;
        }
        setSentMessages(Array.isArray(response) ? response : []);
    }

    useEffect(() => {
        if (conversationId == null) return;
        setUpSentMessages();
    }, [conversationId]);

    return { sentMessages };
}

export default useSentMessages;
